(<template>
  <div>
    <auth-tabs :links="authLinks" />
  </div>
</template>)

<script>
  import AuthFormTabs from '@/components/auth_components/AuthFormTabs';
  import constants from '@/modules/constants';

  export default {
    components: {
      'auth-tabs': AuthFormTabs
    },
    computed: {
      authLinks() {
        return [{
          name: this.$gettext('LOGIN WITH EMAIL'),
          path: this.$makeRoute({name: 'SignIn'})
        }, {
          name: this.$gettext('LOGIN WITH PHONE'),
          path: this.$makeRoute({name: 'SignIn', query: {option: 'phone'}})
        }, {
          name: this.$gettext('CREATE AN ACCOUNT'),
          path: this.$makeRoute({name: 'SignUp'})
        }];
      }
    },
    beforeMount() {
      if (!constants.GOOGLE_RECAPTCHA_SITE_KEY || window.recaptchaReady) return;
      window.recaptchaReady = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${constants.GOOGLE_RECAPTCHA_SITE_KEY}`;
        script.onload = resolve;
        script.onerror = () => {
          window.recaptchaReady = null;
          resolve();
        };
        document.head.appendChild(script);
      });
    }
  };
</script>

<style>
  .grecaptcha-badge {
    bottom: 140px !important;
    z-index: 1000 !important;
  }
</style>
